import { getField } from '@/config/columns/';
import { formatValue } from './formatValue';

// 生成表格数据
// 范围：
// 1. 全媒体大盘报表
// 2. TOP 汇总
export function createTableData(data) {
  if (!data || data instanceof Array) {
    return [];
  }
  return calculateIncr(data);
}

export function calculateIncr(data) {
  const { date, compare_date } = data;
  let _date = date ? formatObjectData(date) : {};
  let _compare = compare_date ? formatObjectData(compare_date) : {};

  const increase = {};
  const increasePercent = {};
  Object.keys(_date).forEach((key) => {
    const l = _date[key];
    const r = _compare[key];
    increase[key] = calculateIncrease(l, r);
    increasePercent[key] = calculateIncreasePercent(l, r);
  });

  increase.date = '涨幅';
  increasePercent.date = '涨幅百分比';

  return [_date, _compare, increase, increasePercent];
}

// 生成 TOP 表格数据
export function createTopTableData(data) {
  if (!data || data.length < 1) {
    return [];
  }
  return data.map((item) => {
    const current = {};
    const _key = item.index;
    const convertKeys = ['date_index', 'compare_date_index', 'add'];
    Object.keys(item).forEach((key) => {
      if (key === 'add-rate') {
        current[key] = parseFloat((item[key] * 100).toFixed(2));
      } else if (convertKeys.includes(key)) {
        current[key] = formatData(_key, item[key]);
      } else {
        current[key] = item[key];
      }
      current._id = item.user_agent_id || item.product_id;
      current._name = item.user_agent_name || item.product_name;
    });
    return current;
  });
}

// 生成类型表格数据
export function createTypeTableData(data) {
  if (!data || data instanceof Array) {
    return [];
  }
  let result = [];
  Object.keys(data).forEach((key) => {
    result = result.concat(calculateIncr(data[key]));
  });
  return result;
}

// 生成图表数据
// 范围：
// 1. 全媒体大盘报表
// 2. TOP 汇总
export function createChartData(data) {
  if (!data || data.length === 0) return null;
  const chartData = {};
  const [d1, d2, i, p] = data;
  Object.keys(d1).forEach((key) => {
    if (key !== 'date') {
      const _d1 = createBaseChartData(d1, key);
      _d1._raw = [i, p];
      const _d2 = createBaseChartData(d2, key);
      _d2._raw = [i, p];
      chartData[key] = {
        base: [[_d1], [_d2]],
      };
    }
  });
  return chartData;
}

// 生成 TOP 图表
export function createTopChartData(data) {
  const d1 = [];
  const d2 = [];
  const list = data.slice(0, 10);
  list.forEach((item) => {
    d1.push({
      key: item.index,
      label: item.date,
      xAxis:
        item._name +
        (item.media_type ? ` 媒体：${item.media_type}` : '') +
        (item.adslot_type ? ` 栏位：${item.adslot_type}` : ''),
      series: item.date_index,
      type: 'bar',
      _raw: item,
    });

    d2.push({
      key: item.index,
      label: item.compare_date,
      xAxis:
        item._name +
        (item.media_type ? ` 媒体：${item.media_type}` : '') +
        (item.adslot_type ? ` 栏位：${item.adslot_type}` : ''),
      series: item.compare_date_index,
      type: 'bar',
      _raw: item,
    });
  });
  return { base: [d1, d2] };
}

// 生成 Type 图表
export function createTypeChartData(data, index, date) {
  const start = date[0].format('YYYY-MM-DD');
  const end = date[1].format('YYYY-MM-DD');

  const mapping = {};
  data.forEach((item) => {
    const date = item.date;
    if (mapping[date]) {
      mapping[date].push(item);
    } else {
      mapping[date] = [item];
    }
  });

  const increase = mapping['涨幅'];
  const increasePercent = mapping['涨幅百分比'];

  const startData = mapping[start] || [];

  const total = startData.reduce((prev, current) => {
    return prev + current[index];
  }, 0);

  const base = startData.map((item, _index) => {
    return {
      key: index,
      label: item.date,
      xAxis: item.type,
      series: item[index],
      type: 'pie',
      _raw: item,
      _rate: [increase[_index], increasePercent[_index]],
      _total: formatValue(index, total),
    };
  });

  const endData = mapping[end] || [];

  const total1 = endData.reduce((prev, current) => {
    return prev + current[index];
  }, 0);

  const compare = endData.map((item, _index) => {
    return {
      key: index,
      label: item.date,
      xAxis: item.type,
      series: item[index],
      type: 'pie',
      _raw: item,
      _rate: [increase[_index], increasePercent[_index]],
      _total: formatValue(index, total1),
    };
  });

  return { base, compare, type: 'pie' };
}

// 创建图表统一数据结构
export function createBaseChartData(data, key) {
  return {
    key,
    label: data.date,
    xAxis: getField(key) ? getField(key).name : key,
    series: data[key],
    type: 'bar',
  };
}

// 格式化对象数据
export function formatObjectData(obj) {
  const current = {};
  Object.keys(obj).forEach((key) => {
    current[key] = formatData(key, obj[key]);
  });
  return current;
}

// 格式化数据
export function formatData(key, value) {
  const moneyKeys = ['cost_total', 'ecpm', 'acp'];
  const percentKeys = ['filled_rate', 'ctr'];
  // 非数字直接返回当前值
  if (isNaN(Number(value))) {
    return value;
    // 金额：除以 100 保留两位小数
  } else if (moneyKeys.includes(key)) {
    return parseFloat((parseFloat(value) / 100).toFixed(2));
    // 百分比：乘以 100 保留两位小数
  } else if (percentKeys.includes(key)) {
    return parseFloat((parseFloat(value) * 100).toFixed(2));
  } else {
    const v =
      typeof value === 'number'
        ? parseFloat(value.toFixed(2))
        : parseFloat(parseFloat(value).toFixed(2));
    return v;
  }
}

// 计算涨幅
export function calculateIncrease(l, r) {
  const diff = l - r;
  if (isNaN(diff)) return '-';
  return parseFloat(diff.toFixed(2));
}

// 计算涨幅百分比
export function calculateIncreasePercent(l, r) {
  if (isNaN(l) || isNaN(r) || r === 0) return '-';
  const diff = calculateIncrease(l, r);
  const percent = parseFloat(((diff / r) * 100).toFixed(2));
  return percent;
}
